import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VesselMetadata, VesselOption } from '../../models/setup/setup.models';
import { DbContext, DbTable } from '../data/dbcontext.service';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/throw';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class VesselService {
  config = AppConfig.settings;
  vesselTable: DbTable;
  vesselMetadataTable: DbTable;
  private editorCache: VesselOption | null = null;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext
  ) {
    this.vesselTable = this.dbContext.tables.find(t => t.name === 'Vessel');
    this.vesselMetadataTable = this.dbContext.tables.find(t => t.name === 'VesselMetadata');
  }

  async getVesselMetadata(): Promise<VesselMetadata> {
    const url = `${this.config.apiUrl}api/vessels/metadata`;
    return this.http
      .get<VesselMetadata>(url)
      .toPromise();
  }

  async getEditor(): Promise<VesselOption> {
    if (this.editorCache) {
      return this.editorCache;
    }

    const inMemoryEditor = await this.dbContext.get(this.vesselTable, 1);

    if (inMemoryEditor) {
      this.editorCache = inMemoryEditor;
      return inMemoryEditor;
    }

    const localStorageEditor = localStorage.getItem('vessel_editor');

    this.editorCache = JSON.parse(localStorageEditor);
    return this.editorCache;
  }

  getLocalVessels(): Promise<VesselMetadata> {
    return this.dbContext.get(this.vesselMetadataTable, 1);
  }

  saveSetup(editor: VesselOption) {
    // save this to local storage too, so that the app remembers the vessel choice (only applicable in local or webtest environments)
    this.editorCache = editor;
    localStorage.setItem('vessel_editor', JSON.stringify(editor));
    return this.dbContext.addOrUpdate(this.vesselTable, 1, editor);
  }

  deleteSetup() {
    this.editorCache = null;
    localStorage.removeItem('vessel_editor');
    this.dbContext.remove(this.vesselTable, 1);
  }

  isNonJackingVessel(vessel: VesselOption): boolean {
    return vessel?.isNonJacking === true;
  }

  async isCurrentVesselNonJacking(): Promise<boolean> {
    const vessel = await this.getEditor();
    return this.isNonJackingVessel(vessel);
  }
}



// WEBPACK FOOTER //
// ./src/services/vessel/vessel.service.ts